import * as React from 'react';
export const IcIndustry = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5 6a1 1 0 01-.71-1.71 3.67 3.67 0 014-.76c1 .25 1.48.34 2-.24a1.003 1.003 0 111.42 1.42 3.67 3.67 0 01-4 .76c-1-.25-1.48-.34-2 .24A1 1 0 015 6zM20.55 10.17a1 1 0 00-.94-.09L16 11.63V11a1 1 0 00-1.39-.92L11 11.63V11a1 1 0 00-1.39-.92L7 11.2V8a1 1 0 00-1-1H4a1 1 0 00-1 1v11a2 2 0 002 2h14a2 2 0 002-2v-8a1 1 0 00-.45-.83zM9 16.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm4 0a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm4 0a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z'
      fill='currentColor'
    />
  </svg>
);
